import { t } from "@lingui/macro"
import {
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    Stack,
} from "@mui/material"
import { observer } from "mobx-react"

import { useCallback } from "react"

import { DateTimePicker } from "src/components/DateTimePicker"
import { Avatar } from "src/components/Avatar"
import { FormFieldSet } from "src/components/FormFieldSet"
import { CaseDetailStore } from "src/modals/cases-v2-detail/store"
import { useStore } from "src/store/lib/useStore"
import { useUniqueId } from "src/lib/unique-id"

export const AssigneeSection = observer(() => {
    const store = useStore(CaseDetailStore)
    const assignedToId = useUniqueId()

    const handleOnDateChangeClick = useCallback(
        (date: Date) => store.form.set("implementationDate", date),
        [store.form],
    )

    const onSelectValueChange = useCallback(
        (assignedToId: string) =>
            store.form.set("assignedTo", Number(assignedToId)),
        [store.form],
    )

    return (
        <FormFieldSet>
            <Stack spacing={2} paddingBottom={{ sm: 4, md: 4 }}>
                <FormControl fullWidth>
                    <InputLabel id={assignedToId}>
                        {t`cases-detail-modal.assignee-section.assigned-to-label`}
                    </InputLabel>
                    <Select
                        fullWidth
                        value={String(store.form.get("assignedTo") ?? "")}
                        onChange={(event) =>
                            onSelectValueChange(event.target.value)
                        }
                        labelId={assignedToId}
                        label={t`cases-detail-modal.assignee-section.assigned-to-label`}
                        error={Boolean(store.form.error("assignedTo"))}
                    >
                        {store.handlers.map((handler) => (
                            <MenuItem key={handler.id} value={handler.id}>
                                <Stack direction="row" spacing={1}>
                                    <Avatar name={handler.name} />
                                    <span>{handler.name}</span>
                                </Stack>
                            </MenuItem>
                        ))}
                    </Select>
                    {Boolean(store.form.error("assignedTo")) && (
                        <FormHelperText
                            error={Boolean(store.form.error("assignedTo"))}
                        >
                            {store.form.error("assignedTo")}
                        </FormHelperText>
                    )}
                </FormControl>
                <DateTimePicker
                    label={t`cases-detail-modal.assignee-section.implementation-date-label`}
                    value={store.form.get("implementationDate")}
                    onChangePicker={(date) =>
                        handleOnDateChangeClick(date as Date)
                    }
                    helperText={store.form.error("implementationDate")}
                    error={Boolean(store.form.error("implementationDate"))}
                    inputId="implementation-date"
                />
            </Stack>
        </FormFieldSet>
    )
})
